import { handleActions } from 'redux-actions';
import { initialState } from './constants';
import { getIndustriesHash } from './actions';

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [getIndustriesHash]: {
    next: (state: State.Industries, action: any): State.Industries => ({
      ...state,
      industriesHash: action.payload,
      industriesFetched: true,
    }),

    throw: (state: State.Industries, action: any): State.Industries => ({
      ...state,
      error: action.payload, // TODO
    }),
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
export default handleActions(ACTION_HANDLERS, initialState);
